import { initContract } from '@ts-rest/core';
import { createApi } from './ts-rest';
import type { CopilotMessage, ServerSideCopilotTool } from '@customerio/hydra-copilot';

const c = initContract();
export const contract = c.router({
  /**
   * Notifications API
   */
  getNotifications: {
    method: 'GET',
    path: '/accounts/:accountId/notifications',
    pathParams: c.type<{ accountId: number }>(),
    responses: {
      200: c.type<{
        notifications: Array<{
          id: number;
          title: string;
          body: string;
          link_text: string;
          link_url: string;
          activated: number;
          created: number;
          updated: number;
          viewed: number;
        }>;
      }>(),
    },
    summary: 'Get all notifications',
  },
  markNotificationsAsViewed: {
    method: 'POST',
    path: '/accounts/:accountId/notifications/mark_as_viewed',
    pathParams: c.type<{ accountId: number }>(),
    body: c.type<{
      ids: number[];
    }>(),
    responses: {
      200: c.type<void>(),
    },
    summary: 'Mark notifications as viewed',
  },
  /**
   * Copilot API
   */
  startCopilotSession: {
    method: 'POST',
    path: '/environments/:workspaceId/copilot',
    pathParams: c.type<{ workspaceId: number }>(),
    body: c.type<object>(),
    responses: {
      200: c.type<{
        session_id: string;
        tools: ServerSideCopilotTool[];
      }>(),
    },
    summary: 'Start a new copilot session',
  },
  destroyCopilotSession: {
    method: 'DELETE',
    path: '/environments/:workspaceId/copilot/:sessionId',
    pathParams: c.type<{ workspaceId: number; sessionId: string }>(),
    responses: {
      200: c.type<void>(),
    },
    summary: 'Stop a copilot session',
  },
  getCopilotSessionMessages: {
    method: 'GET',
    path: '/environments/:workspaceId/copilot/:sessionId',
    pathParams: c.type<{ workspaceId: number; sessionId: string }>(),
    responses: {
      200: c.type<{
        messages: CopilotMessage[];
      }>(),
    },
    summary: 'Get messages from a copilot session',
  },
});

const { api, query } = createApi(contract, {
  baseUrl: '/v1',
});

export type Contract = typeof contract;

export { api, query };
